// ── Product page slider (Swiper) ──────────────────────────────────────────────

function getSliderSettings() {
	return {
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-btn--next",
			prevEl: ".swiper-btn--prev",
		},
	};
}

function getSubSliderProductSettings() {
	return {
		slidesPerView: 3,
		direction: "vertical",
		navigation: false,
	};
}

function updatethumbnail() {
	let productList = document.querySelector(".product__media-list img");
	let mediaThumbHeight = document.querySelector(".product__media-sublist");

	if (productList) {
		productList.addEventListener('load', () => {
			let mediaHeight = productList.offsetHeight;
			if (mediaThumbHeight) {
				if (window.innerWidth > 1200) {
					mediaThumbHeight.style.height = mediaHeight + "px";
				}
				if (window.innerWidth < 1200) {
					mediaThumbHeight.style.height = "100%";
				}
			}
		});
	}

	if (productList?.complete) {
		productList?.dispatchEvent(new Event('load'));
	}
}

const sliderInit = (isUpdate) => {
	const desktopSliderEl = Array.from(document.querySelectorAll('.product-section .js-media-list'))
		.find(function(el) { return !el.closest('.mobile_product_grid'); });
	if (!desktopSliderEl) return;
	{
		let slider = new Swiper(desktopSliderEl, {
			slidesPerView: 1,
			navigation: {
				nextEl: ".swiper-btn--next",
				prevEl: ".swiper-btn--prev",
			},
			a11y: false,
			thumbs: {
				swiper: document.querySelector(".js-media-sublist").swiper,
			},
			on: {
				slideChangeTransitionStart: function () {
					document
						.querySelector(".js-media-sublist")
						.swiper.slideTo(
							document.querySelector(".js-media-list").swiper.activeIndex
						);
				},
				slideChange: function () {
					window.pauseAllMedia();
					this.params.noSwiping = false;
				},
				slideChangeTransitionEnd: function () {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						this.slides[this.activeIndex]
							.querySelector(".shopify-model-viewer-ui__button--poster")
							.removeAttribute("hidden");
					}
				},
				touchStart: function (s, e) {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						if (
							!this.slides[this.activeIndex]
								.querySelector("model-viewer")
								.classList.contains("shopify-model-viewer-ui__disabled")
						) {
							this.params.noSwiping = true;
							this.params.noSwipingClass = "swiper-slide";
						} else {
							this.params.noSwiping = false;
						}
					}
				},
			},
		});

		if (isUpdate) {
			setTimeout(function () {
				slider.update();
				updatethumbnail();
			}, 50);
		}
	}
};

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".product-section .js-media-sublist") &&
		document.querySelectorAll(".product-section .js-media-sublist").length > 0
	) {
		let subSlider = new Swiper(".js-media-sublist", {
			centeredSlides: true,
			centeredSlidesBounds: true,
			slideToClickedSlide: true,
			watchSlidesProgress: true,
			updateOnWindowResize: true,
			slidesPerView: 3,
			spaceBetween: 4,
			direction: "horizontal",
			navigation: false,
			freeMode: false,
			preloadImages: false,
			lazy: true,
			a11y: false,
			breakpoints: {
				1200: {
					direction: "vertical",
					slidesPerView: 3,
					allowTouchMove: true,
				},
			},
			on: {
				touchEnd: function (s, e) {
					let range = 5;
					let diff = (s.touches.diff = s.isHorizontal()
						? s.touches.currentX - s.touches.startX
						: s.touches.currentY - s.touches.startY);
					if (diff < range || diff > -range) s.allowClick = true;
				},
			},
			transitionStart: function () {
				document
					.querySelector(".js-media-list")
					.swiper.slideTo(
						document.querySelector(".js-media-sublist").swiper.activeIndex
					);
			},
		});

		if (subSlider && subSlider.slides && subSlider.slides.length <= 3) {
			subSlider.params.centeredSlides = false;
			subSlider.update();
		}

		if (isUpdate) {
			setTimeout(function () {
				subSlider.update();
			}, 50);
		}
	}
};

let allSections = document.querySelectorAll("section");

window.addEventListener("resize", () => {
	allSections.forEach((prodSection) => {
		if (prodSection.classList.contains("product-section")) {
			setTimeout(() => {
				updatethumbnail();
			}, 50);
		}
	});
});

document.addEventListener("visibilitychange", function () {
	allSections.forEach((prodSection) => {
		if (prodSection.classList.contains("product-section")) {
			setTimeout(() => {
				updatethumbnail();
			}, 50);
		}
	});
});

document.addEventListener("DOMContentLoaded", function () {
	allSections.forEach((prodSection) => {
		if (prodSection.classList.contains("product-section")) {
			setTimeout(() => {
				updatethumbnail();
			}, 50);
		}
	});
});

// ── Model name / size update on variant change ────────────────────────────────

document.addEventListener("DOMContentLoaded", () => {
  function updateModelSizeText() {
    const modalSizeDiv = document.querySelectorAll(".size_model-content .main-text-model");
    const selectedVariant = document.querySelector('.product-form__controls-group .color-swatch-input:checked:not([data-cross-sell-list] *)');

    if (selectedVariant && modalSizeDiv) {
      const selectedValue = selectedVariant.getAttribute("data-model-sizing");
      modalSizeDiv.forEach((div) => {
        div.textContent = selectedValue;
      });
    }
  }

  updateModelSizeText();

  const variants = document.querySelectorAll(".product-form__controls-group .color-swatch-input:not([data-cross-sell-list] *)");
  if (variants.length) {
    variants.forEach((variant) => {
      variant.addEventListener("change", () => {
        updateModelSizeText();
      });
    });
  }
});

// ── Size Chart scroll ─────────────────────────────────────────────────────────

function bindSizeChartHandler(container = document) {
  const sizeChartLink = container.querySelector(".ctm_sizechart_btn_txt");
  const accordion = container.querySelector("#ctm_size_chart");

  if (sizeChartLink && accordion) {
    sizeChartLink.addEventListener("click", function () {
      accordion.scrollIntoView({ behavior: "smooth", block: "center" });

      const title = accordion.querySelector(".about__accordion-title");
      if (title && !title.classList.contains("active")) {
        title.click();
      }

      const button = accordion.querySelector("button[aria-expanded]");
      if (button) button.focus();
    });
  }
}

function openSizeChartAccordion(container = document) {
  if (window.location.hash !== "#ctm_size_chart") return;

  const accordion = container.querySelector("#ctm_size_chart");
  if (accordion) {
    accordion.scrollIntoView({ behavior: "smooth", block: "center" });

    const title = accordion.querySelector(".about__accordion-title");
    if (title && !title.classList.contains("active")) {
      title.click();
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  bindSizeChartHandler();
  openSizeChartAccordion();
});

window.addEventListener("quickview:load", () => {
  const quickViews = document.querySelectorAll(".quick-add-modal__content-wrapper");
  quickViews.forEach((quickView) => {
    bindSizeChartHandler(quickView);
    openSizeChartAccordion(quickView);
  });
});

// ── Shop Promise shadow DOM styling ──────────────────────────────────────────

customElements.whenDefined('delivery-promise-wc').then(() => {
  const promiseWC = document.querySelector('delivery-promise-wc');

  if (!promiseWC) return;

  const shadowRoot = promiseWC.shadowRoot;
  if (!shadowRoot) return;

  const style = document.createElement('style');
  style.textContent = `
    .ContainerCommon__Container.ShopPromiseLayout__Clickable.ContainerCommon__FontOverride {
        background-color: transparent !important;
        padding: 0 !important;
    }
    .PromiseShell_Promise {
      background-color: transparent !important;
      padding: 0 !important;
    }
    .ProductPageContainer__Spacer {
      margin: 5px 0 !important;
    }
    .Text__Text.Text__regular, .TextField__InputWrapper input[type='text'], .Button__button {
      color: black !important;
    }
    .BlockStack__BlockStack > .InlineStack__InlineStack + .Text__Text.Text__inherit.Text__bodyMd.Text__regular {
      display: none !important;
    }
    .TextField__InputWrapper input[type='text'] , .InlineStack__InlineStack .Button__button {
      border: 1px solid black !important;
    }
  `;

  shadowRoot.appendChild(style);

}).catch(() => {});

// ── Digital gift card variant selector ───────────────────────────────────────

document.querySelectorAll('.ctm-digital-gift-card').forEach(container => {
  const display = container.querySelector('.product-form-color-value');
  const radios = container.querySelectorAll('.ctm-variant-selector input[type="radio"]');

  const selected = container.querySelector('input[type="radio"]:checked');
  if (selected) display.textContent = selected.value;

  radios.forEach(r => r.addEventListener('change', e => display.textContent = e.target.value));
});

// ── Selected variant name display ─────────────────────────────────────────────

document.addEventListener("DOMContentLoaded", () => {
  const variantNameEl = document.getElementById("selected-variant-name");

  if (!variantNameEl) return;

  document.addEventListener("variant:change", (event) => {
    const variant = event.detail.variant;
    if (variant) {
      variantNameEl.textContent = variant.title;
    }
  });

  const productForm = document.querySelector("form[action^='/cart/add']");
  if (productForm && window.productVariants) {
    productForm.addEventListener("change", () => {
      const selectedOptions = Array.from(
        productForm.querySelectorAll("select[name^='options'], input[name^='options']:checked")
      ).map(el => el.value);

      const currentVariant = window.productVariants.find(variant =>
        variant.options.every((opt, i) => opt === selectedOptions[i])
      );

      if (currentVariant) {
        variantNameEl.textContent = currentVariant.title;
      }
    });
  }
});

// ── Radio label selected state ────────────────────────────────────────────────

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.product-form__input--radios').forEach(function (fieldset) {

    fieldset.addEventListener('change', function (e) {
      if (e.target.type === "radio") {
        fieldset.querySelectorAll('label').forEach(function (label) {
          label.classList.remove('selected');
        });

        const selectedLabel = fieldset.querySelector(`label[for="${e.target.id}"]`);
        if (selectedLabel) {
          selectedLabel.classList.add('selected');
        }
      }
    });

    const radios = fieldset.querySelectorAll('input[type="radio"]');
    if (radios.length === 1) {
      const singleRadio = radios[0];
      const singleLabel = fieldset.querySelector(`label[for="${singleRadio.id}"]`);
      singleRadio.checked = true;
      if (singleLabel) {
        singleLabel.classList.add('selected');
      }
    }

    const precheckedRadio = fieldset.querySelector('input[type="radio"]:checked');
    if (precheckedRadio) {
      const precheckedLabel = fieldset.querySelector(`label[for="${precheckedRadio.id}"]`);
      if (precheckedLabel) {
        precheckedLabel.classList.add('selected');
      }
    }
  });
});
